import "taltech-styleguide/build/css/main.css";
import "./App.css";
import { RouterProvider } from "react-router-dom";
import {
  ConsoleLogger,
  LoggingConfig,
  LogLevel,
} from "@dirootie-core/logging-types";
import { InterfaceProvider } from "./components-common/_runtime/interface/active-screen.provider";

import { DefaultPropsProvider, ScreenProvider } from "@components-system";
import { component_defaults } from "@components-defaults";
import { appRouter } from "./_runtime/AppRouter";
import { LayoutProvider } from "./components-system/layouts/context";
import { publicLayout } from "./_website/_common/layout.public";
import { layoutWorkspace } from "./_website/_common/layout.workspace";
import { indexBy, map } from "ramda";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useUserContext } from "./_runtime/iam/session.context";
import { useEffect, useMemo, useState } from "react";
import { Loader } from "taltech-styleguide";
import { EventType } from "@azure/msal-browser";

const loggingConfig: LoggingConfig = {
  level: LogLevel.ALL,
  provider: "Console",
};
const logger = new ConsoleLogger(loggingConfig);
const initialLayouts = [publicLayout, layoutWorkspace];
export const App = () => {
  const { instance } = useMsal();
  const [loading, setLoading] = useState(true);
  const [router, setRouter] = useState<any>(null);
  const isAuthenticated = useIsAuthenticated();
  const userProfile = useUserContext();
  const isAuth = useMemo(() => isAuthenticated, [isAuthenticated]);
  const role = useMemo(() => userProfile.role, [userProfile.role]);

  instance.addEventCallback((event: any) => {
    if (
      event.eventType === EventType.INITIALIZE_START ||
      event.eventType === EventType.HANDLE_REDIRECT_START ||
      event.eventType === EventType.ACQUIRE_TOKEN_START
    ) {
      setLoading(true);
    }
    if (
      event.eventType === EventType.INITIALIZE_END ||
      event.eventType === EventType.HANDLE_REDIRECT_END ||
      event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
      event.eventType === EventType.ACQUIRE_TOKEN_FAILURE
    ) {
      setTimeout(() => setLoading(false), 1000);
    }
    if (event.eventType === EventType.LOGOUT_SUCCESS) {
      instance.setActiveAccount(null);
    }
  });

  useEffect(() => {
    const routes = appRouter(isAuth, role ? role : "STUDENT");
    setRouter(routes);
  }, [isAuth, role]);

  return (
    <DefaultPropsProvider<typeof component_defaults> value={component_defaults}>
      <ScreenProvider>
        <LayoutProvider initialLayouts={initialLayouts}>
          <InterfaceProvider>
            {role === undefined && loading ? (
              <Loader fullScreen></Loader>
            ) : (
              <RouterProvider
                key={role?.toString()}
                router={router}
              ></RouterProvider>
            )}
          </InterfaceProvider>
        </LayoutProvider>
      </ScreenProvider>
    </DefaultPropsProvider>
  );
};

export default App;
